import React, { useLayoutEffect } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import { useCurrentUser } from '../../_services/hooks/user';

import { TopMenu } from './TopMenu';

import './Layout.css';

export const Layout = withRouter(({ children }) => {
  const location = useLocation();
  const { currentUserIsCustomer } = useCurrentUser();

  // App cache: if a new version is available, load it here. Safest place to do it as between page navigations
  useLayoutEffect(() => {
    if (!location.state && localStorage.getItem('appUpdated') === 'true') {
      console.log('Reloading page to refresh cache');
      localStorage.removeItem('appUpdated');
      window.location.reload(); // Refresh the browser
    }
  }, [location]);

  if (currentUserIsCustomer)
    return (
      <div className="customer-layout-container">
        <TopMenu />
        {children}
      </div>
    );

  return (
    <>
      <div className="admin-layout-container">
        <TopMenu />
        {children}
      </div>
    </>
  );
});
